<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <template>
          <v-col cols="12" sm="6" md="6" v-if="!item['@id']">
            <v-file-input
              v-model="item.file"
              accept=".gcode"
              :error-messages="fileErrors"
              :label="$t('global.fileinput')"
              required
            >
              <template v-slot:selection="{ text, index }">
                <v-chip v-if="index < 2" color="secondary" dark label small>
                  {{ text }} - {{ convertToMo(item.file.size) }} Mo
                </v-chip>
                <span v-else-if="index === 2">
                  +{{ item.file.length - 2 }}
                </span>
              </template>
            </v-file-input>
          </v-col>
        </template>
          <v-col cols="12" sm="6" md="6" v-if="item['name']">
          <v-text-field
              v-model="item.name"
              :error-messages="nameErrors"
              :label="$t('global.name')"
              @input="$v.item.name.$touch()"
              @blur="$v.item.name.$touch()"
          /></v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6"  v-show="!item.designFile || !designfileProp">
          <v-combobox

              v-if="designFileSelectItems"
              v-model="item.designFile"
              :items="designFileSelectItems"
              :error-messages="designFileErrors"
              :no-data-text="$t('global.no_result')"
              :placeholder="$t('global.no_select')"
              clearable
              :label="$t('prodfile.designfile')"
              item-text="name"
              item-value="@id"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
              v-if="machineSelectItems"
              v-model="item.machine"
              :items="machineSelectItems"
              :error-messages="machineErrors"
              :no-data-text="$t('global.no_result')"
              :placeholder="$t('global.no_select')"
              clearable
              :label="$t('machine.machine')"
              item-text="name"
              item-value="@id"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
              v-if="toolrefSelectItems"
              v-model="item.tool"
              :items="toolrefSelectItems"
              :error-messages="toolErrors"
              :no-data-text="$t('global.no_result')"
              :placeholder="$t('global.no_select')"
              clearable
              :label="$t('tool.tool')"
              item-text="name"
              item-value="@id"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
              v-if="surfaceSelectItems"
              v-model="item.surface"
              :items="surfaceSelectItems"
              :error-messages="surfaceErrors"
              :no-data-text="$t('global.no_result')"
              :placeholder="$t('global.no_select')"
              clearable
              :label="$t('printingsurface.printingsurface')"
              item-text="name"
              item-value="@id"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
              v-if="materialSelectItems"
              v-model="item.material"
              :items="materialSelectItems"
              :error-messages="materialErrors"
              :no-data-text="$t('global.no_result')"
              :placeholder="$t('global.no_select')"
              clearable
              :label="$t('material.material')"
              item-text="name"
              item-value="@id"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
              v-if="nozzleSelectItems"
              v-model="item.nozzle"
              :items="nozzleSelectItems"
              :error-messages="nozzleErrors"
              :no-data-text="$t('global.no_result')"
              :placeholder="$t('global.no_select')"
              clearable
              :label="$t('nozzle.nozzle')"
              item-text="name"
              item-value="@id"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
              v-model.number="item.quantity"
              :error-messages="quantityErrors"
              :label="$t('prodfile.quantity')"
              required
              @input="$v.item.quantity.$touch()"
              @blur="$v.item.quantity.$touch()"
          />
        </v-col>
      </v-row>
      <v-row v-if="item['@id']">
        <v-col cols="12" sm="6" md="6">
          <v-text-field
              v-model.number="item.timeExecution"
              :error-messages="timeExecutionErrors"
              :label="$t('prodfile.timeexecution')"
              required
              @input="$v.item.timeExecution.$touch()"
              @blur="$v.item.timeExecution.$touch()"
          />
        </v-col>
      </v-row>
      <v-row v-if="item['@id']">
        <v-col cols="12" sm="6" md="6">
          <v-text-field
              v-model.number="item.materialConsumed"
              :error-messages="materialConsumedErrors"
              :label="$t('prodfile.materialconsumed')"
              required
              @input="$v.item.materialConsumed.$touch()"
              @blur="$v.item.materialConsumed.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
              v-model.number="item.layerHeight"
              :error-messages="layerHeightErrors"
              :label="$t('prodfile.layerHeight')"
              required
              @input="$v.item.layerHeight.$touch()"
              @blur="$v.item.layerHeight.$touch()"
          />
        </v-col>
      </v-row> 
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <v-text-field
              v-model="item.comment"
              :error-messages="commentErrors"
              :label="$t('prodfile.comment')"
              required
              @input="$v.item.comment.$touch()"
              @blur="$v.item.comment.$touch()"
          />
        </v-col>
      </v-row>
    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import userHasAccess from '../../mixins/AccessMixin';
import {maxsizefile} from '../../utils/files';

const decimalNumber = {
  bind: function (el) {
    el.handler = function (event) {
      event.target.value = event.target.value.replace(/,/g, '.');
    };
    el.addEventListener('keyup', el.handler);
  },
  unbind: function (el) {
    el.removeEventListener('keyup', el.handler);
  }
};

export default {
  name: 'ProdFileForm',
  mixins: [validationMixin,userHasAccess],
  components: {
    Loading
  },
  directives: {
    decimalNumber
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    },
    designfileProp: {
      type: Object,
      required: false,
      default: null
    }
  },
  mounted() {
    this.machineGetSelectItems();
    this.toolrefGetSelectItems();
    this.surfaceGetSelectItems();
    this.materialGetSelectItems();
    this.nozzleGetSelectItems();
    this.designFileGetSelectItems();
  },
  data() {
    return {
      file: null,
      name: null,
      designFile: null,
      machine: null,
      tool: null,
      surface: null,
      material: null,
      nozzle: null,
      quantity: null,
      timeExecution: null,
      materialConsumed: null,
      layerHeight: null,
      comment: null,
    };
  },
  computed: {
    isLoading() {
      return (this.isLoading_machine ||
          this.isLoading_toolref ||
          this.isLoading_printingsurface ||
          this.isLoading_material ||
          this.isLoading_nozzle ||
          this.isLoading_designfile
      );
    },
    ...mapFields('machine', {
      machineSelectItems: 'selectItems',
      isLoading_machine : 'isLoading'
    }),
    ...mapFields('toolref', {
      toolrefSelectItems: 'selectItems',
      isLoading_toolref : 'isLoading'
    }),
    ...mapFields('printingsurface', {
      surfaceSelectItems: 'selectItems',
      isLoading_printingsurface : 'isLoading'
    }),
    ...mapFields('material', {
      materialSelectItems: 'selectItems',
      isLoading_material : 'isLoading'
    }),
    ...mapFields('nozzle', {
      nozzleSelectItems: 'selectItems',
      isLoading_nozzle : 'isLoading'
    }),
    ...mapFields('designfile', {
      designFileSelectItems: 'selectItems',
      isLoading_designfile : 'isLoading'
    }),



    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    nameErrors() {
      const errors = [];

      if (!this.$v.item.name.$dirty) return errors;

      has(this.violations, 'name') && errors.push(this.violations.name);

      return errors;
    },
    designFileErrors() {
      const errors = [];

      if (!this.$v.item.designFile.$dirty) return errors;

      has(this.violations, 'designFile') && errors.push(this.violations.designFile);


      return errors;
    },
    commentErrors() {
      const errors = [];

      if (!this.$v.item.comment.$dirty) return errors;

      has(this.violations, 'comment') && errors.push(this.violations.comment);


      return errors;
    },
    machineErrors() {
      const errors = [];

      if (!this.$v.item.machine.$dirty) return errors;

      has(this.violations, 'machine') && errors.push(this.violations.machine);


      return errors;
    },
    toolErrors() {
      const errors = [];

      if (!this.$v.item.tool.$dirty) return errors;

      has(this.violations, 'tool') && errors.push(this.violations.tool);


      return errors;
    },
    surfaceErrors() {
      const errors = [];

      if (!this.$v.item.surface.$dirty) return errors;

      has(this.violations, 'surface') && errors.push(this.violations.surface);


      return errors;
    },
    materialErrors() {
      const errors = [];

      if (!this.$v.item.material.$dirty) return errors;

      has(this.violations, 'material') && errors.push(this.violations.material);


      return errors;
    },
    nozzleErrors() {
      const errors = [];

      if (!this.$v.item.nozzle.$dirty) return errors;

      has(this.violations, 'nozzle') && errors.push(this.violations.nozzle);


      return errors;
    },
    quantityErrors() {
      const errors = [];

      if (!this.$v.item.quantity.$dirty) return errors;

      has(this.violations, 'quantity') && errors.push(this.violations.quantity);

      !this.$v.item.quantity.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    timeExecutionErrors() {
      const errors = [];

      if (!this.$v.item.timeExecution.$dirty) return errors;

      has(this.violations, 'timeExecution') && errors.push(this.violations.timeExecution);

      return errors;
    },
    materialConsumedErrors() {
      const errors = [];

      if (!this.$v.item.materialConsumed.$dirty) return errors;

      has(this.violations, 'materialConsumed') && errors.push(this.violations.materialConsumed);

      return errors;
    },
    layerHeightErrors() {
      const errors = [];

      if (!this.$v.item.layerHeight.$dirty) return errors;

      has(this.violations, 'layerHeight') && errors.push(this.violations.layerHeight);

      return errors;
    },
    fileErrors() {
      const errors = [];

      if (!this.$v.item.file.$dirty) return errors;

      has(this.violations, 'file') && errors.push(this.violations.file);

      !this.$v.item.file.required && errors.push(this.$t('global.field_required'));

      if(this.item.file != null && !this.$v.item.file.maxsizefile){
        if(!this.userHasAccess('unlimited_size_file')){
          errors.push(this.$t('global.sizeerror_100'));
        }
      }

      has(this.violations, 'file') && errors.push(this.violations.file);
      
      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
    convertToMo(sizeInBytes) {
      return (sizeInBytes / (1024 * 1024)).toFixed(2);
    },
    designFilePropAssign() {
      if (this.designfileProp) {
        this.designFile = this.designfileProp;
        this.item.designFile = this.designfileProp;
      }
    },
    ...mapActions({
      machineGetSelectItems: 'machine/fetchSelectItems'
    }),
    ...mapActions({
      toolrefGetSelectItems: 'toolref/fetchSelectItems'
    }),
    ...mapActions({
      surfaceGetSelectItems: 'printingsurface/fetchSelectItems'
    }),
    ...mapActions({
      materialGetSelectItems: 'material/fetchSelectItems'
    }),
    ...mapActions({
      nozzleGetSelectItems: 'nozzle/fetchSelectItems'
    }),
    ...mapActions({
      designFileGetSelectItems: 'designfile/fetchSelectItems'
    }),
    
  },
  watch: {
    designfileProp: function() {
      this.designFilePropAssign()
    },
    designFileSelectItems() {
      this.designFilePropAssign()
      if (this.$route.params) {
        if (this.item.designFile == null && (this.$route.params.parent != null)) {
          for (var i = 0; i < this.designFileSelectItems.length; i++) {
            if (this.designFileSelectItems[i]['@id'] == this.$route.params.parent ) {
              this.item.designFile = this.designFileSelectItems[i];
            }
          }
        }
      }
    },

  },
  validations() {
    if (this.item['@id']) {
      return {
        item: {
          name: {
          },
          designFile: {
          },
          machine: {
          },
          tool: {
          },
          surface: {
          },
          material: {
          },
          nozzle: {
          },
          quantity: {
            required,
          },
          timeExecution: {
          },
          materialConsumed: {
          },
          layerHeight: {
          },
          comment: {}
        }
      }
    } else {
      return {
        item: {
          file: {
            required,
            maxsizefile : maxsizefile(100),
          },
          name: {
          },
          designFile: {
          },
          machine: {
          },
          tool: {
          },
          surface: {
          },
          material: {
          },
          nozzle: {
          },
          quantity: {
            required,
          },
          timeExecution: {
          },
          materialConsumed: {
          },
          layerHeight: {
          },
          comment: {}
        }
      }

    }
  }
};
</script>